<template>
  <AddEditTemplate
    v-if="formData && !loading"
    :isEditMode="isEditMode"
    addEditType="Instructor"
    :initialData="formData"
    :submitAction="submitForm"
  >
    <template #default="{ formData }">
      <AddEditFormGroup
        label="First Name"
        fieldId="firstName"
        v-model="formData.firstName"
        required
      />
      <AddEditFormGroup
        label="Last Name"
        fieldId="lastName"
        v-model="formData.lastName"
        required
      />
      <AddEditFormGroup
        label="Email"
        fieldId="email"
        v-model="formData.email"
        type="email"
        required
      />
      <AddEditFormGroup
        label="Phone"
        fieldId="phone"
        v-model="formData.phone"
        type="tel"
      />
      <AddEditFormGroup
        label="Role"
        fieldId="instructorRoleId"
        v-model="formData.instructorRoleId"
        component="select"
        :options="instructorRoleOptions"
      />
      <AddEditFormGroup
        v-if="useLoginStore().isAdmin"
        label="Pay Rate"
        fieldId="payRate"
        v-model="formData.payRate"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        v-if="useLoginStore().isAdmin"
        label="Charge Rate"
        fieldId="chargeRate"
        v-model="formData.chargeRate"
        type="number"
        step="any"
      />
      <FileUpload
        label="Instructor Image"
        fieldId="image"
        v-model="formData.image"
      />
    </template>
  </AddEditTemplate>
</template>

<script>
import ActiveInstructorsAPIService from "src/servicehandlers/ActiveInstructorsAPIService";
import AddEditTemplate from "./AddEditTemplate.vue";
import AddEditFormGroup from "./AddEditFormGroup.vue";
import FileUpload from "../../../../components/HiloComponents/FileUpload.vue";
import { useLoginStore } from "@/stores/loginStore";
const activeInstructorsAPIService = new ActiveInstructorsAPIService();

export default {
  components: { FileUpload, AddEditFormGroup, AddEditTemplate },
  data() {
    return {
      isEditMode: false,
      loading: true,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        instructorRoleId: "",
        image: "",
      },
      instructorRoleOptions: [],
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getInstructor(this.$route.params.id);
    }
    await this.getInstructorRoleOptions();
    this.loading = false;
  },
  methods: {
    useLoginStore,
    async getInstructor(id) {
      try {
        const response =
          await activeInstructorsAPIService.getInstructorById(id);
        this.formData = {
          ...response,
          lastName: response.user.lastName,
          firstName: response.user.firstName,
          email: response.user.email,
          phone: response.user.phone,
          image: response.user.image,
          instructorRoleId: response.instructorRole?.id,
        };
      } catch (error) {}
    },
    async getInstructorRoleOptions() {
      try {
        this.instructorRoleOptions =
          await activeInstructorsAPIService.getInstructorRoles();
      } catch (error) {}
    },
    async submitForm(formData) {
      try {
        if (this.isEditMode) {
          await activeInstructorsAPIService.update(
            this.$route.params.id,
            formData,
          );
        } else {
          await activeInstructorsAPIService.create(formData);
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped></style>
